import { useState } from "react";
import { SlideOver } from "@/components/ui/slide-over";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { useLineMachines } from "@/features/lines/hooks";
import { useSetSimilarMachine } from "@/features/simulations/hooks";

interface SimilarMachineModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lineId: string;
  machineId: string;
  machineName: string;
}

// Indica uma máquina semelhante (com histórico medido) de onde
// emprestar o comportamento p/ cold-start tier 2. A relação é persistida e reutilizada.
export function SimilarMachineModal({
  open,
  onOpenChange,
  lineId,
  machineId,
  machineName,
}: SimilarMachineModalProps) {
  const { data: machines = [] } = useLineMachines(lineId);
  const setSimilar = useSetSimilarMachine(lineId);
  const [similarId, setSimilarId] = useState("");

  const options = machines.filter((m) => m.id !== machineId);

  function save(value: string | null) {
    setSimilar.mutate(
      { machineId, similarMachineId: value },
      { onSuccess: () => onOpenChange(false) }
    );
  }

  return (
    <SlideOver open={open} onOpenChange={onOpenChange} title="Máquina semelhante">
      <div className="space-y-4 p-1">
        <p className="text-sm text-muted-foreground">
          <b className="text-foreground">{machineName}</b> não tem histórico próprio suficiente.
          Indique uma máquina semelhante (com histórico medido) para o motor emprestar o
          comportamento — sem indicação, a cascata desce para spec nominal.
        </p>
        <div className="space-y-1.5">
          <Label htmlFor="similar">Máquina-fonte</Label>
          <Select id="similar" value={similarId} onChange={(e) => setSimilarId(e.target.value)}>
            <option value="">Selecione…</option>
            {options.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </Select>
        </div>
        <div className="flex gap-2">
          <Button disabled={!similarId || setSimilar.isPending} onClick={() => save(similarId)}>
            Salvar semelhança
          </Button>
          <Button variant="outline" disabled={setSimilar.isPending} onClick={() => save(null)}>
            Limpar
          </Button>
        </div>
      </div>
    </SlideOver>
  );
}
